export default __webpack_public_path__ + "static/media/notification-bell-full.8a8f2414.svg";